import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/workout-controls.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';
import { initNative } from './lib/nativeBridge';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Native-Hülle (Capacitor) initialisieren – No-Op im Browser
initNative();

// Service Worker registrieren (PWA) + Auto-Update bei neuer Version
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});

    // Wenn ein neuer SW die Kontrolle übernimmt (Update), Seite neu laden.
    // Guard: Beim ersten Registrieren (kein vorheriger Controller) NICHT neu laden.
    let hadController = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) {
        window.location.reload();
      }
      hadController = true;
    });
  });
}
